import CompleteBlob from './CompleteBlob'

export default CompleteBlob
